import React, { createContext, useContext } from "react";

export const DrawerContext = createContext(false);

DrawerContext.displayName = "DrawerContext";

export const withDrawerContextProvider = (Component, value = true) => props => (
  <DrawerContext.Provider value={value}>
    <Component {...props} />
  </DrawerContext.Provider>
);

export const useDrawerContext = () => useContext(DrawerContext);
